module.exports = __webpack_public_path__ + "static/conceptIMG-5f5b07b17ba65418aa418c61536b4e9b.svg";